import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { validationsQuestionsDynamiques } from 'src/app/shared/questionnaire.metadata';
import { ValidationService } from '../../../../shared/validation/validation.service';
import { FormulaireService } from '../../../formulaire.service';
import { ModeRenduService } from '../../../mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-lieux-sad',
  templateUrl: './lieux-sad.component.html',
  styleUrls: ['./lieux-sad.component.css']
})
export class LieuxSadComponent implements OnInit, OnDestroy {
  public rootForm: UntypedFormGroup;
  step: number = 0;
  @Input()
  erreursMap: Map<string, string>;
  
  private subLieuxSad: Subscription;
  private valeurTableauA4f_1: number[] = [];
  private valeurTableauA4f_2: number[] = [];
  private valeurTableauA4f_3: number[] = [];

  constructor(
    private formulaireService: FormulaireService,
    private validationService: ValidationService,
    public modeRenduService: ModeRenduService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.lieuxSad) {
      (this.rootForm.get('moyens') as UntypedFormGroup).setControl('lieuxSad', new UntypedFormArray([]));
    }
   }

  ngOnInit(): void {
    setTimeout(() => {
      //Controles bloquants
        for (let index = 0; index < this.lieuxSad.length; index++) {
        this.ajoutValidateurCroiseLieuxSad(index);
        this.lieuxSad.controls[index].updateValueAndValidity();
      }

      // Tri apres rechargement questionnaire
      this.trierLieuxSad();
    
      // Calcul des totaux lieux Sad
      this.subLieuxSad = this.lieuxSad.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
          if (valeur instanceof Array) {

            this.valeurTableauA4f_1 = [];
            this.valeurTableauA4f_2 = [];
            this.valeurTableauA4f_3 = [];
            
            valeur.forEach((lieux, index) => {
              //Calcul totaux auto A4f
              this.calculAutoTotauxA4f(index, this.valeurTableauA4f_1, 'aaLieuSadNbPerm', 'aaLieuSadNbPermTot');      
              this.calculAutoTotauxA4f(index, this.valeurTableauA4f_2, 'aaLieuSadNbPermEtp', 'aaLieuSadNbPermEtpTot');      
              this.calculAutoTotauxA4f(index, this.valeurTableauA4f_3, 'aaLieuSadNbVict', 'aaLieuSadNbVictTot');      
            });
          }
        });
      this.lieuxSad.updateValueAndValidity();
    }, 1000);

  }

  ngOnDestroy(): void {
    if (this.subLieuxSad) {
      this.subLieuxSad.unsubscribe();
    }
  }

  get lieuxSad() {
    return this.rootForm.get('moyens').get('lieuxSad') as UntypedFormArray;
  }

  public get formulaire(): UntypedFormGroup {
    return this.rootForm.get('moyens') as UntypedFormGroup;
  }

  public ajouterLieuxSad() {
    // on récupère le nombre total avant ajout
    let nbLieux = this.formulaire.get('aaLieuSadNb').value;

    // Pour les validators, on utilise ce qui est dans le questionnaire.metadata
    this.lieuxSad.push(new UntypedFormGroup({
      aaLieuSadRang: new UntypedFormControl(this.lieuxSad.length, Validators.required),
      aaLieuSadCodCom: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuSadCodCom')),
      aaLieuSadQp: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuSadQp')),
      aaLieuSadNbPerm: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuSadNbPerm')),
      aaLieuSadNbPermEtp: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuSadNbPermEtp')),
      aaLieuSadNbVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuSadNbVict'))
    }));
    this.step = this.lieuxSad.length - 1 ;
    this.ajoutValidateurCroiseLieuxSad(this.lieuxSad.length - 1);

    // on incrémente le nombre total de lieux
    this.formulaire.get('aaLieuSadNb').setValue(++nbLieux);
  }

  private ajoutValidateurCroiseLieuxSad (index: number) {
    const currentForm: UntypedFormGroup = this.lieuxSad.controls[index] as UntypedFormGroup;
    currentForm.setValidators([
      this.validationService.ctrlA70Sad,
      this.validationService.ctrlA71Sad
    ]);
  }

  public supprimerLieuxSad(index?: number) {
    if (index >= 0) {
      const lieuxValeur = this.lieuxSad.controls[index].value;
      if (confirm(`Êtes vous sûr de supprimer ${lieuxValeur['aaLieuSadCodCom']} ?`)) {
        this.lieuxSad.removeAt(index);
      }
    } else {
      this.lieuxSad.removeAt(this.lieuxSad.length - 1);
    }
    // On maj les rangs
    this.majRangs();
    // on met à jour le nombre total de lieux
    this.formulaire.get('aaLieuSadNb').setValue(this.lieuxSad.controls.length);
  }

  public setStep(index: number): void {
    this.step = index;
  }

  private trierLieuxSad(): void {
    this.lieuxSad.controls.sort((a, b) => {
      if (a.get('aaLieuSadRang').value < b.get('aaLieuSadRang').value) {
            return -1;
      } else if (a.get('aaLieuSadRang').value > b.get('aaLieuSadRang').value) {
            return 1;
      } else {
            return 0;
      }
    });
  }

  private majRangs(): void {
    for (let index = 0; index < this.lieuxSad.length; index++) {
      this.lieuxSad.controls[index].get('aaLieuSadRang').setValue(index);
    }
    this.trierLieuxSad();
  }

  private calculAutoTotauxA4f(index: number, tabBoucle: number[], varBoucle: string, totBoucle: string): void {
    tabBoucle.splice(index,1,this.lieuxSad.controls[index].get(varBoucle).value);
    let sum = tabBoucle.reduce((a,b)=>a+b,0);
    this.formulaire.get(totBoucle).setValue(sum);
  }

}
